/** @jsxImportSource @emotion/react */
import { useCreateGroupFitnessActivityMutation } from "@goodgym/graphql/hooks";
import { useConfirm } from "@goodgym/hooks";

import { useNavigate } from "react-router-dom";
type CreateGroupFitnessActivityInput = {
  sessionId: string;
  description: string;
  startedAt: string;
  distance: number;
  type: string;
  addressId?: string;
  accessibleToilets: boolean;
  bagDrop?: boolean;
  toilets?: boolean;
  addressLine1?: string; 
  addressLine2?: string; 
  city?: string; 
  postCode?: string; 
  region?: string; 
  accessNotes?: string; 
  otherInformation?: string; 
  runReturn: boolean
  sessionSlug: string
};

export const useCreateGroupFitnessActivity = () => {
  const { confirm } = useConfirm();
  const navigate = useNavigate();


  const [createGroupFitnessActivity] = useCreateGroupFitnessActivityMutation({
    onError: console.log,
  });

  return (params: CreateGroupFitnessActivityInput) =>
    
    async (e: React.MouseEvent) => {
      e.preventDefault();

      confirm({
        title: "Are you sure you want to create this group fitness activity?",
        text: "You are creating a new group fitness activity",
        alert: false,
        onConfirm: async () => {
          const result = await createGroupFitnessActivity({
            variables: {
              ...params,
            },
            optimisticResponse: {
              createGroupFitnessActivity: {
                groupFitnessActivity: {
                  __typename: "GroupFitnessActivity",
                  id: "temp-id", 
                  description: params.description,
                  startedAt: params.startedAt,
                  distance: params.distance,
                  type: params.type,
                  accessibleToilets: params.accessibleToilets,
                  runReturn: params.runReturn || false,
                  toilets: params.toilets || false,
                  bagDrop: params.bagDrop || false, 
                  
                  address: {
                    __typename: "Address",
                    id: "",
                    line1: "",
                    city: "",
                    postcode: "",
                    line2: "",
                    lat: null,
                    lng: null,
                  },
                },
              },
            },
          });

          const created =
            result.data?.createGroupFitnessActivity.groupFitnessActivity;
          if (!created) {
            alert("Error creating group fitness activity");
          } else {
            navigate(`/v3/sessions/${params.sessionSlug}`);
          }
        },
      });
    };
};